module.exports = __webpack_public_path__ + "static/media/proximanova-bold-webfont.6aff4903.woff";